<template>
  <app-shell v-if="!$route.meta.bare">
    <transition name="page" mode="out-in">
      <router-view :key="$route.path"/>
    </transition>
  </app-shell>
  <router-view v-else/>
</template>

<script>
import AppShell from '@/components/layout/AppShell.vue'

export default {
  name: 'App',
  components: {
    AppShell
  }
}
</script>

<style>
@import "assets/styles.css";
</style>
